module.exports = __webpack_public_path__ + "img/icon-title.c0f3b58e.png";